<!--Titre du right-pane - au complet () - plus bouton ajouter-->
<div class="main-page-toolbar">
  <h1 class="page-titre">
    <mat-icon>{{ IconGlobalPage }}</mat-icon
    >{{ TitreGlobalPage }}
  </h1>
</div>

<div class="main-page-container">
  <!-- ********************************************************************* -->
  <!-- container prioncial de la page -->
  <div class="listpage-container">
    <div class="listpage-header">
      <!-- ********************************************************************* -->
      <!-- liste des champs de recherche -->
      <div class="listpage-search-container">
        <mat-form-field appearance="outline">
          <mat-label>Date</mat-label>
          <mat-date-range-input [rangePicker]="pickerRange">
            <input matStartDate placeholder="Date début" [(ngModel)]="recherche.SCAN1_DateTime_DATE_FILTER_GE" name="SCAN1_DateTime_DATE_FILTER_GE" />
            <input matEndDate placeholder="Date fin" [(ngModel)]="recherche.SCAN1_DateTime_DATE_FILTER_LE" name="SCAN1_DateTime_DATE_FILTER_LE" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="pickerRange"></mat-datepicker-toggle>
          <mat-date-range-picker #pickerRange></mat-date-range-picker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>ID Recept. en-tête</mat-label>
          <input matInput [(ngModel)]="recherche.ItemReceptionHeaderId" name="ItemReceptionHeaderId" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>ID Recept. Détail</mat-label>
          <input matInput [(ngModel)]="recherche.ItemReceptionDetailId" name="ItemReceptionDetailId" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>#Produit</mat-label>
          <input matInput [(ngModel)]="recherche.ProductNumber" name="ProductNumber" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Barcode</mat-label>
          <input matInput [(ngModel)]="recherche.ScannedBarCode" name="ScannedBarCode" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Scan1 Final Destination</mat-label>
          <mat-select [(ngModel)]="recherche.SCAN1_FinalAction" name="Scan1ActionFinale">
            <mat-option [value]="">Tout</mat-option>
            <mat-option *ngFor="let destination of pieuvreDestinations" [value]="destination">{{ destination }} </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Réception ORIG Destination</mat-label>
          <mat-select [(ngModel)]="recherche.ItemReceptionDetail_PrecalcPieuvreDestination" name="ItemReceptionDetail_PrecalcPieuvreDestination">
            <mat-option [value]="">Tout</mat-option>
            <mat-option *ngFor="let destination of pieuvreDestinations" [value]="destination">{{ destination }} </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- ********************************************************************* -->
      <!-- Bouton recherche et count -->
      <div class="recherche-btn-container">
        <button type="button" mat-stroked-button color="primary" (click)="effacerRecherche()"><mat-icon>delete</mat-icon> Effacer</button>
        <button type="button" mat-flat-button color="primary" (click)="rechercher()"><mat-icon>search</mat-icon> Rechercher</button>
        <span class="pagination-count">{{ count ? count + " élément(s) trouvé(s)" : " " }}</span>
      </div>
    </div>

    <!-- LISTE -->
    <div class="listpage-body">
      <table
        class="table-liste table-liste-clickable"
        mat-table
        #table
        [dataSource]="dataSource"
        matSort
        matSortStart="desc"
        (matSortChange)="sortData($event)"
      >
        <!-- ********************************************************************* -->
        <!-- colonnes autogénérées -->
        <ng-container matColumnDef="{{ champ['key'] }}" *ngFor="let champ of ColumnsOrder">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [ngClass]="champ['headerCSSClass']"
            class="sub-header"
            [class.align-right]="champ['type'] == 'number' || champ['type'] == 'currency'"
            [class.align-center]="champ['type'] == 'boolean'"
          >
            {{ champ["nom"] }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            [class.align-right]="champ['type'] == 'number' || champ['type'] == 'currency'"
            [class.align-center]="champ['type'] == 'boolean'"
          >
            <span *ngIf="champ['expand'] !== undefined; else not_expand">
              <span *ngIf="champ['type'] == 'string' || champ['type'] == 'number'">{{ row[champ["expand"]][champ["key"]] }}</span>
              <span *ngIf="champ['type'] == 'currency'">{{ row[champ["expand"]][champ["key"]] | currency }}</span>
              <span *ngIf="champ['type'] == 'date'">{{ row[champ["expand"]][champ["key"]] | formatDate : "D" }}</span>
              <span *ngIf="champ['type'] == 'datetime'">{{ row[champ["expand"]][champ["key"]] | formatDate : "DT" }}</span>
              <span *ngIf="champ['type'] == 'boolean' && row[champ['expand']][champ['key']] == true">
                <mat-icon>check</mat-icon>
              </span>
            </span>

            <ng-template #not_expand>
              <span *ngIf="champ['type'] == 'string' || champ['type'] == 'number'">{{ row[champ["key"]] }}</span>
              <span *ngIf="champ['type'] == 'currency'">{{ row[champ["key"]] | currency }}</span>
              <span *ngIf="champ['type'] == 'date'">{{ row[champ["key"]] | formatDate : "D" }}</span>
              <span *ngIf="champ['type'] == 'datetime'">{{ row[champ["key"]] | formatDate : "DT" }}</span>
              <span *ngIf="champ['type'] == 'boolean' && row[champ['key']] == true">
                <mat-icon>check</mat-icon>
              </span>
            </ng-template>
          </td>
        </ng-container>

        <!-- ********************************************************************* -->
        <!-- colonnes hardcodées -->
        <ng-container matColumnDef="removeTrace">
          <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
          <td mat-cell *matCellDef="let row">
            <button mat-stroked-button color="primary" (click)="DeleteSelectedTraceExecution(row['id'], row['ItemReceptionDetailId'])">
              <mat-icon>delete</mat-icon>Supprimer cette trace
            </button>
          </td>
        </ng-container>
        <!--<ng-container matColumnDef="PrecalcPieuvreDestination">
          <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
          <td  *matCellDef="let row">
            {{row.ItemReceptionDetail['PrecalcPieuvreDestination']}}
          </td>
        </ng-container>
        <ng-container matColumnDef="HH_ConsumerNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
          <td mat-cell *matCellDef="let row">
            {{row.ItemReceptionDetail['HH_ConsumerNumber']}}
          </td>
        </ng-container>
        <ng-container matColumnDef="SupplierInvoiceNumber">
          <th class="header-group_info-produit" mat-header-cell *matHeaderCellDef mat-sort-header>
            #Commande Fournisseur
          </th>
          <td mat-cell *matCellDef="let row">
            {{row.ItemReceptionDetail['SupplierInvoiceNumber']}}
          </td>
        </ng-container>-->

        <!-- ********************************************************************* -->
        <!-- Creation des RowsHeader principaux - faut matcher avec les colonnes crééees.... -->
        <ng-container matColumnDef="header-row-group_info-produit">
          <th class="main-header-group header-group_info-produit" mat-header-cell *matHeaderCellDef [attr.colspan]="4">Info base</th>
        </ng-container>
        <ng-container matColumnDef="header-row-group_info-scan1">
          <th class="main-header-group header-group_info-scan1" mat-header-cell *matHeaderCellDef [attr.colspan]="9">Scan1</th>
        </ng-container>

        <!-- ********************************************************************* -->
        <!-- création du tableau -->
        <tr mat-header-row *matHeaderRowDef="['header-row-group_info-produit', 'header-row-group_info-scan1']"></tr>
        <tr mat-header-row *matHeaderRowDef="overrideChampsDiplay; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: overrideChampsDiplay" (click)="clickRow(row.id)" [class.row-highlight]="currentId == row.id"></tr>

        <!-- ********************************************************************* -->
        <!-- Zone si pas de data -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="99">Aucun élément trouvé</td>
        </tr>
      </table>
    </div>

    <!-- ********************************************************************* -->
    <!-- Footer du tableau (PAGING) -->
    <div class="listpage-footer">
      <div class="pagination-container" *ngIf="count != 0">
        Items par page:
        <mat-select
          appearance="inline"
          class="pagination-select"
          [(ngModel)]="rowPerPage"
          style="font-size: 8; width: 5em; padding-left: 10px"
          (selectionChange)="changeRowPerPage($event)"
        >
          <mat-option *ngFor="let count of rowPerPageSelect" [value]="count">{{ count }}</mat-option>
        </mat-select>
        <button mat-icon-button [disabled]="currentPage == 0" (click)="pagination('debut')">
          <mat-icon>first_page</mat-icon>
        </button>
        <button mat-icon-button [disabled]="currentPage == 0" (click)="pagination('precedent')">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <div class="pagination-pages">{{ from }} à {{ to }} de {{ count }}</div>
        <button mat-icon-button [disabled]="to > count || count == 0" (click)="pagination('suivant')">
          <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-icon-button [disabled]="to > count || count == 0" (click)="pagination('fin')">
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <!--fin listpage-container -->

  <!--Mettre l'entité de FORM ici...-->
</div>
